import {connect} from 'react-redux';
import SearchWidget from '../../components/homepage/hero-slider/search-widget/search';

const mapStateToProps = (state) => {
  return {
    supportsMls: state.store.entity.supportsMls,
    idxExclusions: state.store.entity.siteOptions.idxExclusions,
    regionUrlParts: state.store.entity.regionUrlParts,
  };
};

export default connect(mapStateToProps)(SearchWidget);



// WEBPACK FOOTER //
// ./src/containers/homepage/search-widget.js